import { render, staticRenderFns } from "./program_capaian.vue?vue&type=template&id=4fca11f4&"
import script from "./program_capaian.vue?vue&type=script&lang=js&"
export * from "./program_capaian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports